import { siteTypesEnum } from '../../helpers';
import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

export const REQUEST = 'SITE_SPEAKERS_REQUEST';
export const SUCCESS = 'SITE_SPEAKERS_SUCCESS';
export const FAILURE = 'SITE_SPEAKERS_FAILURE';

const initialState = {
  loaded: false,
};

export default function siteSpeakersReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign({}, state, {
        error: true,
        statusCode: action.data.statusCode,
        ...action.data.json,
      });

    default:
      return state;
  }
}

export function fetchSiteSpeakersRequest(data) {
  return { type: REQUEST, data };
}

export function fetchSiteSpeakersSuccess(data) {
  return { type: SUCCESS, data };
}

export function fetchSiteSpeakersFailure(data) {
  return { type: FAILURE, data };
}

export function fetchSiteSpeakersAction(search) {
  return function (dispatch, getState, { Api, i18n }) {
    dispatch(fetchSiteSpeakersRequest());

    const {
      pageConfig: { previewMode, siteId, siteType },
      siteType: {
        data: { primaryLocale = 'en' },
      },
    } = getState();

    const { EVENT } = siteTypesEnum();
    const apiMethod =
      siteType === EVENT ? 'fetchSiteSpeakers' : 'fetchSiteTrainers';
    const searchParams = search
      ? search + '&primaryLocale=' + primaryLocale
      : '?primaryLocale=' + primaryLocale;

    return Api()
      .cache(true)
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      [apiMethod]({ siteId, searchParams })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchSiteSpeakersSuccess(response));
        } else {
          return dispatch(fetchSiteSpeakersFailure(response));
        }
      });
  };
}
